/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function HouseSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M218.76465,103.70117l-.001-.001L138.75684,30.96484a15.93607,15.93607,0,0,0-21.52637.001L37.23633,103.7002A16.03346,16.03346,0,0,0,32,115.53857V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V115.53906A16.03466,16.03466,0,0,0,218.76465,103.70117Z" />
    </Svg>
  );
}

export default HouseSimple;
